import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef } from 'vue';

import BrandIcon from '@/components/icons/BrandIcon.vue';
import InitialIcon from '@/components/InitialIcon.vue';
import { AppName, BrandColors } from '@/data/Branding';
import { FullUserDetails, LimitedUserDetails } from '@/data/datatypes/UserDetails';
import { convertUUIDtoNumber } from '@/data/helpers/InitialsHelper';
import { useUserStore } from '@/stores/User';

interface Props {
  user?: LimitedUserDetails;
  alt?: string;
  altDisplayName?: string;
  title?: string;
  showOnlineStatus?: boolean;
  bordered?: boolean;
  large?: boolean;
  displayNumber?: number;
}
interface Emits {
  (e: 'click', event: MouseEvent): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UserIdent',
  props: {
    user: null,
    alt: null,
    altDisplayName: null,
    title: null,
    showOnlineStatus: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
    large: { type: Boolean },
    displayNumber: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click', event: MouseEvent): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as { user?: LimitedUserDetails, alt?: string, altDisplayName?: string, title?: string, showOnlineStatus: boolean, bordered: boolean, large?: boolean, displayNumber?: number }

const userStore = useUserStore();

const guestDisplay: string = 'Guest';





const currentUser: ComputedRef<FullUserDetails | null> = computed(() => {
  return userStore.currentUser;
});

const colour: ComputedRef<string | null> = computed(() => {
  if (!props.user || (!props.user.color && !props.user.id)) {
    return null;
  }

  if (props.user.color) {
    return props.user.color;
  }

  // If the user doesn't have a colour set, then use one based on their ID
  const colorIndex = convertUUIDtoNumber(props.user.id) % BrandColors.DEFAULT_GENERATED_COLOURS.length;
  return BrandColors.DEFAULT_GENERATED_COLOURS[colorIndex];
});

const avatar: ComputedRef<string | null> = computed(() => {
  return props.user?.avatar ?? null;
});

const toInitialise: ComputedRef<string | undefined> = computed(() => {
  if (props.user && props.user.displayName) {
    return props.user.displayName;
  } else if (props.user && props.user.email) {
    return props.user.email;
  } else if (props.altDisplayName) {
    return props.altDisplayName;
  } else if (props.user && props.user.guest) {
    return guestDisplay;
  }
  return undefined;
});

const isSystem: ComputedRef<boolean> = computed(() => {
  return props.altDisplayName === AppName;
});

const identTitle: ComputedRef<string> = computed(() => {
  if (props.title) {
    return props.title;
  }
  if (!props.user) {
    return guestDisplay;
  }
  return props.user.displayName || props.user.email || guestDisplay;
});

const doNotDisturbTitle: ComputedRef<string> = computed(() => {
  if (doNotDisturb.value) {
    return 'Do not disturb mode enabled';
  }
  return '';
});

const doNotDisturbStatusIconName: ComputedRef<string> = computed(() => {
  return 'fullColour/do-not-disturb-dash-white';
});

const userOnline: ComputedRef<boolean> = computed(() => {
  if (currentUser.value && props.user?.id === currentUser.value.id) {
    return !currentUser.value.appearOffline;
  }
  return userStore.onlineUserIds.includes(props.user?.id ?? '');
});

const doNotDisturb: ComputedRef<boolean> = computed(() => {
  return props.user?.doNotDisturbActive || false;
});

function handleClick(event: MouseEvent): MouseEvent {
  emit('click', event);
  return event;
}

return { __sfc: true,userStore, guestDisplay, props, emit, currentUser, colour, avatar, toInitialise, isSystem, identTitle, doNotDisturbTitle, doNotDisturbStatusIconName, userOnline, doNotDisturb, handleClick, BrandIcon, InitialIcon }
}

})